export const frontendVersion = '3.01' // update version in public/version.json and App.js too !!!
